var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
export class ThinkAndRevealScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return 1;
    }
    get reachedPoints() {
        if (this.question.wasKnown)
            return 1;
        return 0;
    }
    get progressiveReachablePoints() {
        return this.maxPoints;
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        if (this.question.answer.completeDate)
            return false;
        if (this.question.answeringState.currentAnswerState !== QuestionAnswerState.Answering)
            return false;
        return this.question.isComplete;
    }
    get legacyEvalText() {
        return '';
    }
    set legacyEvalText(t) {
        // this.question.multipleChoiceLegacy.evaltext = t;
    }
}
__decorate([
    override
], ThinkAndRevealScore.prototype, "maxPoints", null);
__decorate([
    override
], ThinkAndRevealScore.prototype, "reachedPoints", null);
__decorate([
    override
], ThinkAndRevealScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], ThinkAndRevealScore.prototype, "shouldSetCompletedTimestamp", null);
